import type _Vue from 'vue'
import TenantEnum from '@/services/enums/TenantEnum'
import DashUtils from '@/utils/DashUtils'
import KeeyPartnersUtils from '@/utils/KeeyPartnersUtils'
import Utils from '@/utils/Utils'
import YogaUtils from '@/utils/YogaUtils'
import ZenUtils from '@/utils/ZenUtils'
import ZoomcoverUtils from '@/utils/ZoomcoverUtils'

export default function UtilsPlugin(Vue: typeof _Vue, tenant: TenantEnum): void {
  switch (tenant) {
    case TenantEnum.Zoomcover:
      Vue.prototype.$utils = new ZoomcoverUtils()
      break
    case TenantEnum.Yoga:
      Vue.prototype.$utils = new YogaUtils()
      break
    case TenantEnum.Demo02:
      Vue.prototype.$utils = new YogaUtils()
      break
    case TenantEnum.Zen:
      Vue.prototype.$utils = new ZenUtils()
      break
    case TenantEnum.KeeyPartners:
      Vue.prototype.$utils = new KeeyPartnersUtils()
      break
    case TenantEnum.Dash:
      Vue.prototype.$utils = new DashUtils()
      break
    default:

      Vue.prototype.$utils = new Utils()
  }
}
